// extracted by mini-css-extract-plugin
export var grid = "_1m-0";
export var span1 = "_1m-2";
export var span10 = "_1m-b";
export var span10L = "_1m-z";
export var span10M = "_1m-n";
export var span10Xl = "_1m-1b";
export var span11 = "_1m-c";
export var span11L = "_1m-10";
export var span11M = "_1m-o";
export var span11Xl = "_1m-1c";
export var span12 = "_1m-d";
export var span12L = "_1m-11";
export var span12M = "_1m-p";
export var span12Xl = "_1m-1d";
export var span1L = "_1m-q";
export var span1M = "_1m-e";
export var span1Xl = "_1m-12";
export var span2 = "_1m-3";
export var span2L = "_1m-r";
export var span2M = "_1m-f";
export var span2Xl = "_1m-13";
export var span3 = "_1m-4";
export var span3L = "_1m-s";
export var span3M = "_1m-g";
export var span3Xl = "_1m-14";
export var span4 = "_1m-5";
export var span4L = "_1m-t";
export var span4M = "_1m-h";
export var span4Xl = "_1m-15";
export var span5 = "_1m-6";
export var span5L = "_1m-u";
export var span5M = "_1m-i";
export var span5Xl = "_1m-16";
export var span6 = "_1m-7";
export var span6L = "_1m-v";
export var span6M = "_1m-j";
export var span6Xl = "_1m-17";
export var span7 = "_1m-8";
export var span7L = "_1m-w";
export var span7M = "_1m-k";
export var span7Xl = "_1m-18";
export var span8 = "_1m-9";
export var span8L = "_1m-x";
export var span8M = "_1m-l";
export var span8Xl = "_1m-19";
export var span9 = "_1m-a";
export var span9L = "_1m-y";
export var span9M = "_1m-m";
export var span9Xl = "_1m-1a";
export var stretch = "_1m-1";